import listeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { User as IUser } from "@/api/models/user";
import { MainList } from "@/classes/MainList";

export class ListenersListClass extends MainList {
  courseId!: string;
  params: CourseListenersListParams = {
    id: this.courseId,
    limit: 30,
    offset: 0
  };

  constructor(courseId: string, params?: CourseListenersListParams) {
    super();
    this.method = listeners;
    this.params = { ...this.params, ...params };
    this.dataLabel = "listeners";
    this._course = courseId;
    this.list();
  }

  private set _course(value: string) {
    this.courseId = value;
    this.params.id = value;
  }

  search(value: string) {
    this.params.fullName = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }

  get users(): Array<IUser> {
    return this.listItems?.map(el => el.user);
  }

  get listeners(): Array<ICourseListener> {
    return this.listItems;
  }
}
